var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPtreact = function SvgPtreact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E92737",
    d: "M24 21H0V3.45Q0 3 .45 3H24v18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E92737",
    d: "M24 21H0V3.45Q0 3 .45 3H24v18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E92737",
    d: "M24 21H0V3.45Q0 3 .45 3H24v18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D5B2F",
    d: "M9 21H0V3h9v18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M13.854 16.008c-1.582-.048-8.838-4.585-8.888-5.308l.401-.67c.72 1.049 8.137 5.461 8.866 5.305z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M5.282 9.94c-.142.383 1.894 1.643 4.343 3.136 2.448 1.492 4.56 2.414 4.717 2.281.009-.017.076-.133.07-.132-.03.044-.1.058-.212.026-.661-.191-2.387-.984-4.524-2.283S5.68 10.473 5.391 9.965a.3.3 0 0 1-.032-.15h-.007l-.061.108zm8.61 6.09c-.028.048-.078.05-.173.04-.591-.067-2.387-.941-4.513-2.216-2.472-1.483-4.515-2.834-4.293-3.187l.06-.107.012.004c-.2.598 4.03 3.021 4.28 3.175 2.447 1.52 4.51 2.406 4.693 2.176z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M9.765 11.138c1.584-.012 3.538-.217 4.663-.666l-.242-.394c-.665.368-2.63.61-4.434.647-2.134-.02-3.64-.219-4.394-.726l-.23.42c1.388.588 2.81.713 4.637.72",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.493 10.48c-.038.063-.772.316-1.852.503-.733.112-1.689.208-2.881.209A20 20 0 0 1 7 11.017c-1.134-.178-1.72-.426-1.936-.514l.054-.108a8.4 8.4 0 0 0 1.9.504c.696.095 1.61.177 2.738.176a19 19 0 0 0 2.86-.213c1.109-.18 1.714-.41 1.8-.517zm-.212-.4c-.12.098-.719.31-1.772.479-.702.1-1.596.19-2.737.192a18.4 18.4 0 0 1-2.645-.17c-1.069-.14-1.638-.393-1.843-.466q.03-.053.063-.106c.16.08.708.304 1.792.457.666.095 1.554.166 2.633.165a19 19 0 0 0 2.717-.194c1.059-.146 1.628-.417 1.715-.485z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M4.564 13.05c.974.524 3.137.789 5.185.807 1.864.003 4.293-.288 5.2-.77l-.024-.526c-.284.445-2.887.872-5.196.854-2.31-.017-4.455-.375-5.17-.837z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15 12.974v.125c-.137.164-.993.41-2.066.585-.817.125-1.882.22-3.209.22-1.26 0-2.266-.09-3.046-.21-1.232-.18-2.02-.495-2.179-.589l.001-.146c.475.317 1.763.549 2.196.62.774.118 1.774.208 3.028.208 1.32 0 2.38-.094 3.191-.219.77-.111 1.867-.401 2.083-.594m0-.446v.126c-.136.163-.992.41-2.066.584-.816.126-1.881.22-3.208.22-1.261 0-2.266-.09-3.046-.21-1.232-.18-2.02-.494-2.179-.588v-.146c.476.316 1.764.548 2.196.619.775.119 1.774.208 3.029.208 1.32 0 2.38-.094 3.191-.218.77-.112 1.867-.402 2.083-.595",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M9.745 15.918c-2.24-.013-4.16-.612-4.565-.71l.296.463c.716.302 2.588.751 4.29.701 1.703-.05 3.191-.181 4.24-.693l.303-.48c-.715.337-3.146.715-4.564.719",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.12 15.572q-.067.102-.136.2c-.495.175-1.274.359-1.603.412-.672.139-1.711.241-2.633.242-1.985-.03-3.61-.419-4.374-.75l-.061-.107.01-.016.104.04c1.36.488 2.886.682 4.332.717.918.003 1.838-.105 2.582-.239 1.14-.229 1.601-.401 1.743-.48zm.262-.435.004.004-.103.172c-.264.094-.98.304-2.025.45-.689.094-1.117.185-2.487.212-2.567-.066-4.23-.568-4.624-.692l-.059-.113c1.488.39 3.008.66 4.683.689 1.254-.027 1.787-.12 2.47-.213 1.219-.19 1.833-.39 2.017-.449l-.008-.01z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M14.408 12.635c.008 1.476-.746 2.802-1.354 3.386a4.87 4.87 0 0 1-3.33 1.383c-1.486.028-2.887-.943-3.262-1.37-.735-.833-1.333-1.891-1.353-3.318.091-1.611.723-2.734 1.638-3.503s2.134-1.145 3.15-1.118c1.17.03 2.538.606 3.483 1.749.62.748.888 1.56 1.028 2.791M9.738 7.58c2.853 0 5.2 2.326 5.2 5.179s-2.347 5.18-5.201 5.18a5.19 5.19 0 0 1-5.181-5.18 5.19 5.19 0 0 1 5.181-5.18",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.75 7.562c2.857 0 5.187 2.334 5.187 5.196s-2.33 5.196-5.186 5.196-5.186-2.334-5.186-5.196 2.33-5.196 5.186-5.196m-5.07 5.196c0 2.795 2.29 5.081 5.07 5.081 2.782 0 5.073-2.286 5.073-5.081S12.532 7.676 9.75 7.676s-5.072 2.287-5.072 5.082",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.756 7.994c2.605 0 4.75 2.142 4.75 4.76s-2.146 4.759-4.75 4.759-4.75-2.142-4.75-4.76 2.145-4.76 4.75-4.76m-4.637 4.76c0 2.554 2.094 4.644 4.637 4.644s4.636-2.09 4.636-4.645-2.094-4.645-4.636-4.645-4.637 2.09-4.637 4.645",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M9.964 7.662H9.52l-.001 10.177h.446z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.922 7.5h.113V18h-.113zm-.442 0h.114V18h-.115z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M14.94 12.959v-.386l-.313-.293-1.781-.472-2.567-.263-3.09.158-2.2.525-.444.33v.385l1.125-.505 2.671-.42h2.567l1.885.21 1.31.314z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.753 11.954a18 18 0 0 1 3.355.3c.973.194 1.657.438 1.891.712v.135c-.282-.34-1.203-.59-1.913-.733a18 18 0 0 0-3.333-.298c-1.285.003-2.482.125-3.404.305-.74.147-1.726.44-1.849.727v-.14c.068-.2.802-.498 1.832-.705.929-.181 2.128-.301 3.42-.303m0-.446a18 18 0 0 1 3.356.3c.973.195 1.657.438 1.891.712v.136c-.283-.34-1.204-.59-1.913-.733-.935-.183-2.116-.3-3.334-.298-1.285.002-2.476.124-3.398.305-.713.135-1.74.439-1.855.727v-.141c.068-.198.817-.506 1.833-.704.929-.182 2.127-.302 3.42-.304",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M9.73 9.235c1.93-.01 3.613.27 4.383.665l.281.487c-.67-.361-2.486-.737-4.662-.68-1.773.01-3.668.195-4.618.703l.335-.562c.78-.405 2.62-.611 4.28-.613",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.755 9.637c1.1-.003 2.164.059 3.01.212.788.147 1.54.367 1.647.486l.083.147c-.261-.17-.911-.36-1.746-.52-.838-.157-1.902-.21-2.996-.207-1.243-.004-2.208.062-3.036.206-.877.165-1.485.4-1.634.51l.081-.155c.292-.15.754-.329 1.53-.469.858-.157 1.833-.204 3.06-.21m0-.446c1.053-.002 2.093.057 2.904.203.64.124 1.272.319 1.503.492l.122.194c-.207-.23-.987-.449-1.675-.571-.804-.14-1.801-.194-2.855-.203-1.105.003-2.127.07-2.92.215-.756.145-1.244.315-1.45.449l.106-.162c.285-.15.746-.289 1.326-.402.798-.145 1.826-.211 2.938-.215",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M12.33 14.918c-.953-.179-1.91-.205-2.577-.197-3.216.038-4.255.662-4.382.85l-.24-.392c.818-.594 2.57-.928 4.64-.894 1.074.018 2.001.09 2.782.24z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.734 14.665c.895.014 1.773.05 2.621.21l-.061.108c-.788-.146-1.627-.202-2.557-.197-1.187-.01-2.387.102-3.432.402-.33.092-.876.305-.932.48l-.061-.1c.018-.104.348-.32.965-.493 1.197-.344 2.317-.402 3.457-.41m.041-.45c.927.017 1.884.06 2.815.244l-.064.113c-.84-.167-1.643-.222-2.745-.24-1.191.003-2.454.088-3.603.422-.37.109-1.01.342-1.032.528l-.061-.109c.014-.168.568-.387 1.066-.533 1.158-.337 2.424-.424 3.624-.426",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "m14.343 15.239-.386.6-1.11-.988-2.881-1.941-3.248-1.784-1.686-.578.36-.667.122-.067 1.047.262 3.457 1.784 1.99 1.26 1.677 1.207.68.787z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.972 10.564c.295-.2 2.469.77 4.743 2.143 2.268 1.378 4.435 2.934 4.24 3.226l-.065.101-.03.023c.007-.004.04-.044-.003-.152-.096-.319-1.634-1.548-4.185-3.09-2.486-1.486-4.559-2.381-4.766-2.125zm9.45 4.666c.188-.37-1.828-1.89-4.328-3.372-2.556-1.452-4.399-2.306-4.735-2.052l-.075.137c0 .007.002-.01.018-.022.061-.053.163-.05.209-.05.58.008 2.234.771 4.557 2.105 1.017.594 4.299 2.702 4.286 3.295 0 .051.004.061-.015.087z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.5 13.932c0 .704.253 1.341.662 1.807.41.467.967.761 1.585.761.62 0 1.184-.288 1.592-.753A2.75 2.75 0 0 0 12 13.934V9.006L7.5 9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M7.5 13.949v.002c0 .7.254 1.336.663 1.798.409.463.972.751 1.588.751.62 0 1.182-.286 1.59-.747.407-.462.659-1.098.659-1.8V9.001L7.503 9zm3.596-3.915v3.697l-.002.232c0 .061-.003.131-.01.19-.036.348-.176.65-.384.886-.244.276-.58.447-.95.447-.369 0-.697-.177-.942-.454a1.64 1.64 0 0 1-.396-1.076v-3.928z"
  })));
};
export default SvgPtreact;